import { render } from "./avatar.md?vue&type=template&id=12999b02"
import script from "./avatar.md?vue&type=script&lang=js"
export * from "./avatar.md?vue&type=script&lang=js"
script.render = render

export default script